module.exports = __webpack_public_path__ + "static/Spotify_Icon_CMYK_White-d0d7f78423891fc622d41aa0d82630b5.png";